var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flowchart-with-content"},[_c('Flowchart',{staticClass:"flowchart",attrs:{"type":_vm.type,"json":_vm.json}}),_vm._v(" "),_c('FlowContent',{staticClass:"content",attrs:{"type":_vm.type,"json":_vm.json}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d01b821","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/components/FlowchartWithContent.vue
// module id = null
// module chunks = 